import React from 'react';
import { useIntl } from 'react-intl';
import core from '@gin-betting/core';

import globalMsgs from 'messages';

import './prematchTime.scss';

const {
    utils: { formatTimeAndDate },
} = core;

interface Props {
    startTime: string;
}

const PrematchTime: React.FC<Props> = ({ startTime }) => {
    const { formatMessage } = useIntl();
    const { date, time, isToday } = formatTimeAndDate(startTime, {
        // => 01.10 / Oct 01
        // dateFormat: isSmall ? 'dd.MM' : 'MMM dd',
        dateFormat: 'MMM dd',
    });

    return (
        <div styleName="container" className="__app-PrematchTime-container">
            <div styleName="time" className="__app-PrematchTime-time">
                {time}
            </div>
            <div styleName="date" className="__app-PrematchTime-date">
                {isToday ? formatMessage(globalMsgs.todayText) : date}
            </div>
        </div>
    );
};

export default PrematchTime;
